<div class="main-section" id="payment-section-main">
  <div class="main-section-content">
    <ng-template
      #paymnetModal
      let-c="closeEditModal(true)"
      let-d="closeEditModal(true)"
    >
      <!--  Header parts START here  -->
      <div class="modal-header">
        <h4 class="modal-title">Add Biling Information</h4>
        <button
          type="button"
          class="btn btn-close"
          aria-label="Close"
          (click)="closeEditModal(true)"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
      <!-- Header parts ENDS here -->
      <!-- Content Part Starts Here -->
      <div class="modal-body payment-scrollbar">
        <div class="mainPopupModual">
          <div class="col-xl-12 col-lg-12 spacing">
            <form id="payment-form" [formGroup]="billingPaymentForm">
              <div class="form-group">
                <div class="d-flex">
                  <div class="col-6">
                    <label for="FirstName" name="title" class="form-label"
                      >First Name <span class="stariCON">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="firstName"
                      formControlName="firstName"
                      name="firstName"
                      placeholder="First Name"
                    />
                    <p
                      class="errorMessage mb-0"
                      [hidden]="
                        billingPaymentForm?.get('firstName')?.valid ||
                        billingPaymentForm?.get('firstName')?.untouched
                      "
                    >
                      First Name is required
                    </p>
                  </div>
                  <div class="col-6">
                    <label for="LastName" name="title" class="form-label"
                      >Last Name <span class="stariCON">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="lastName"
                      formControlName="lastName"
                      name="lastName"
                      placeholder="Last Name"
                    />
                    <p
                      class="errorMessage mb-0"
                      [hidden]="
                        billingPaymentForm?.get('lastName')?.valid ||
                        billingPaymentForm?.get('lastName')?.untouched
                      "
                    >
                      Last Name is required
                    </p>
                  </div>
                </div>
                <div class="billingAddress mt-2">
                  <div class="col-12">
                    <div class="form-group address-dropdown">
                      <label
                        for="BillingAddress"
                        name="title"
                        class="form-label"
                        >Billing Address <span class="stariCON">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="billingAddress"
                        formControlName="billingAddress"
                        name="billingAddress"
                        placeholder="Billing Address"
                      />
                      <p
                        class="errorMessage mb-0"
                        [hidden]="
                          billingPaymentForm?.get('billingAddress')?.valid ||
                          billingPaymentForm?.get('billingAddress')?.untouched
                        "
                      >
                        Billing Address is required
                      </p>
                      <div
                        *ngIf="showDropdown && filteredAddresses.length > 0"
                        class="dropdown"
                      >
                        <ul class="dropdown-menu show">
                          <li
                            *ngFor="let address of filteredAddresses"
                            (click)="onAddressSelected(address)"
                            class="dropdown-item"
                          >
                            {{ address.azureAddress1 }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 mt-2">
                    <label for="BillingAddress2" name="title" class="form-label"
                      >Billing Address 2</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="billingAddress"
                      formControlName="billingAddress2"
                      name="billingAddress2"
                      placeholder="Billing Address 2"
                    />
                  </div>
                </div>
                <div class="d-flex mt-2">
                  <div class="col-4">
                    <label for="billingCity" name="title" class="form-label"
                      >City <span class="stariCON">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="billingCity"
                      formControlName="billingCity"
                      name="billingCity"
                      placeholder="City"
                    />
                    <p
                      class="errorMessage mb-0"
                      [hidden]="
                        billingPaymentForm?.get('billingCity')?.valid ||
                        billingPaymentForm?.get('billingCity')?.untouched
                      "
                    >
                      City is required
                    </p>
                  </div>
                  <div class="col-4">
                    <label for="billingState" name="title" class="form-label"
                      >State <span class="stariCON">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="billingState"
                      formControlName="billingState"
                      name="billingState"
                      placeholder="State"
                    />
                    <p
                      class="errorMessage mb-0"
                      [hidden]="
                        billingPaymentForm?.get('billingState')?.valid ||
                        billingPaymentForm?.get('billingState')?.untouched
                      "
                    >
                      State is required
                    </p>
                  </div>
                  <div class="col-4">
                    <label for="billingZip" name="title" class="form-label"
                      >Zip <span class="stariCON">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="billingZip"
                      formControlName="billingZip"
                      name="billingZip"
                      placeholder="Zip Code"
                    />
                    <p
                      class="errorMessage mb-0"
                      [hidden]="
                        billingPaymentForm?.get('billingZip')?.valid ||
                        billingPaymentForm?.get('billingZip')?.untouched
                      "
                    >
                      Zip Code is required
                    </p>
                  </div>
                </div>
                <div
                  class="creditCardDetails mt-2"
                  *ngIf="paymentMode === EPaymentMode?.Card; else codNote"
                >
                  <app-stripeconnect-payment
                    [stripeSubmit]="stripeSubmit"
                    [salesOrder]="salesOrder"
                    (sendStripe)="sendStripe($event)"
                    (purchaseBtnProcessing)="purchaseBtnProcessing($event)"
                  >
                  </app-stripeconnect-payment>

                  <div class="codWriteUp mt-2 col-12">
                    <p>
                      Note<span class="stariCON">*</span> The order amount is
                      <b
                        >${{ salesOrder?.totalAmount.toFixed(2)
                        }}{{
                          salesOrder?.customer?.priceLevel?.name === "US"
                            ? " (USD)"
                            : " (CAD)"
                        }}</b
                      >, which you need to pay by Card.
                    </p>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- Content Part Starts Here -->
      <div class="modal-footer">
        <div class="btn-save d-flex justify-content-between">
          <button
            class="btn blue-btn d-flex align-items-center"
            [ngClass]="{ 'btn-loading': isSubmitting }"
            (click)="submit()"
            [disabled]="billingPaymentForm?.invalid || isSubmitting"
          >
            <!-- Spinner -->
            <span
              *ngIf="isSubmitting"
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>

            <!-- Button Text -->
            <span *ngIf="!isSubmitting">
              {{ btnText }}
            </span>
          </button>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<!-- This template will render when COD order-->
<!-- STARTS -->
<ng-template #codNote>
  <div class="codWriteUp mt-2 col-12">
    <p>
      Note<span class="stariCON">*</span> The order amount is
      <b
        >${{ salesOrder?.totalAmount.toFixed(2) }}
        {{
          salesOrder?.customer?.priceLevel?.name === "US" ? " (USD)" : " (CAD)"
        }}</b
      >, which you need to pay Cash on Delivery.
    </p>
  </div>
</ng-template>
<!-- ENDS -->
<!-- Spinner loading STARTS -->
<div class="loading-shade" *ngIf="isLoading">
  <mat-spinner *ngIf="isLoading"></mat-spinner>
</div>
<!-- Spinner loading ENDS -->
